<template>
  <div class="box box-secondary">
    <div class="box-header with-border">
      <h3 class="box-title"><i class="fa fa-line-chart mr-5"></i>Verkaufsstatistik</h3>
      <div class="box-tools pull-right">
        <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="clear"></div>
    <div class="box-body" style="display: block;">
      <div class="row">
        <div class="col-xs-12">
          <ul class="list-group no-margin list-group-unbordered">
            <li v-for="(data, channel) in orders.channels" class="list-group-item">
              <div class="progress-group">
                <span class="progress-text">{{channel}}</span>
                <div class="progress sm no-margin">
                  <div v-if="data.orders > 0" class="progress-bar" :class="['progress-bar-' + channel]" :style="'width:' + Math.round(data.orders * 100 / orders.orders) + '%'"></div>
                  <div v-else class="progress-bar progress-bar-warning" style="width:0%"></div>
                </div>
                <div class="row" :class="['text-' + channel]">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="description-block small border-right">{{data.orders}} {{'orders' | translate}}</div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="description-block small border-right">{{data.items}} {{'items' | translate}}</div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="description-block small border-right">Ø VK: {{data.average | currency}}</div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="description-block small">{{'gesamt' | translate}}: {{data.amount | currency}}</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: ['orders'],
  data () {
    return {
	    timeSelector: '7_days'
    }
  },
  methods: {
    getTotal (key) {
      let total = 0
      let data = this.shipping.data[this.shipping.current_page - 1]
      for (let o in data) {
        for (let k in data[o]) {
          if (key === 'month') {
            total += data[o][k].total
          } else {
            total += data[o][k].channels[key].total
          }
        }
      }
      return total
    },
    getPrevious (array, key) {
      if (typeof this.shipping.data[this.shipping.current_page - 2] !== 'undefined') {
        let data = this.shipping.data[this.shipping.current_page - 2]
        data = Object.keys(data)[0].split('-').reverse().join('-')
        return array[data][key]
      }
      return 0
    },
    getPreviousCombined () {
      if (typeof this.shipping.data[this.shipping.current_page -2] !== 'undefined') {
        let data = this.shipping.data[this.shipping.current_page - 2]
        data = Object.keys(data)[0].split('-').reverse().join('-')
        return this.monthlyShippings[data].order_totals - this.monthlyReturns[data].order_totals
      }
      return 0
    },
    getTotalRevenue () {
      if (typeof this.shipping.data[this.shipping.current_page - 1] !== 'undefined') {
        let data = this.shipping.data[this.shipping.current_page - 1]
        data = Object.keys(data)[0].split('-').reverse().join('-')
        return data in this.monthlyShippings ? this.monthlyShippings[data].order_totals : 0
      }
      return 0
    },
    getTotalReturns () {
      if (typeof this.shipping.data[this.shipping.current_page - 1] !== 'undefined') {
        let data = this.shipping.data[this.shipping.current_page - 1]
        data = Object.keys(data)[0].split('-').reverse().join('-')
        return data in this.monthlyReturns ? this.monthlyReturns[data].order_totals : 0
      }
      return 0
    },
    triggerChanges () {
      this.total = this.getTotal('month')
    },
    processResponse (data) {
      let days = {}
      let retObj = {
        data: [],
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        total: Object.keys(data).length
      }
      for (let x in data) {
        let date = x
        x = x.split('-')
        if (days[x[1] + '-' + x[0]]) {
          if (days[x[1] + '-' + x[0]][x[2]]) {
            days[x[1] + '-' + x[0]][x[2]] = data[date]
          } else {
            days[x[1] + '-' + x[0]][x[2]] = []
            days[x[1] + '-' + x[0]][x[2]] = data[date]
          }
        } else {
          days[x[1] + '-' + x[0]] = {}
          days[x[1] + '-' + x[0]][x[2]] = []
          days[x[1] + '-' + x[0]][x[2]] = data[date]
        }
      }
      Object.keys(days).forEach(key => {
        let obj = {}
        obj[key] = days[key]
        retObj.data.push(obj)
      })
      retObj.total_pages = retObj.data.length
      retObj.current_page = retObj.data.length
      this.shipping = retObj
    },
    getData () {
      API.get(`/statistics/stats/${this.company.id}`)
        .then(res => {
          this.processResponse(res.data.daily_shippings)
          this.monthlyShippings = res.data.monthly_shippings
          this.monthlyReturns = res.data.monthly_returns
          this.total = this.getTotal('month')
        })
        .catch(error => {
          console.log(error)
        })
      }
		},
  mounted () {
  },
  watch: {
		orders () {},
	  timeSelector () {}
  }
}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;
  }
  .progress-bar-schuhede {
    background-color: #EE379A;
  }
  .progress-bar-amazon {
    background-color: #f39c12;
  }
  .progress-bar-spartoo {
    background-color: #DB321B;
  }
  .progress-bar-zalando {
    background-color: #DB321B;
  }
  .progress-bar-ebay {
    background-color: #00c0ef;
  }
  .text-schuhede {
    color: #EE379A;
  }
  .text-amazon {
    color: #f39c12;
  }
  .text-spartoo {
    color: #DB321B;
  }
  .text-zalando {
    color: #DB321B;
  }
  .text-ebay {
    color: #00c0ef;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/StatisticsReport.vue